<div class="app-timeline">
  <div
    *ngFor="let step of steps; let last = last"
    class="app-timeline__step"
    [class.app-timeline__step--completed]="step.status === 'completed'"
    [class.app-timeline__step--current]="step.status === 'current'"
    [class.app-timeline__step--pending]="step.status === 'pending'"
  >
    <div class="app-timeline__marker">
      <span class="app-timeline__dot">
        <i *ngIf="step.status === 'completed'" class="pi pi-check"></i>
      </span>
      <span *ngIf="!last" class="app-timeline__connector"></span>
    </div>
    <div class="app-timeline__content">
      <div class="app-timeline__label">{{ step.label }}</div>
      <div *ngIf="step.description" class="app-timeline__description">{{ step.description }}</div>
    </div>
  </div>
</div>
